import { NextResponse } from "next/server"

import { createSupabaseAdminClient } from "@/lib/supabase/admin"
import { createSupabaseServerClient } from "@/lib/supabase/server"

type ReviewPayload = {
  recipeId: string
  authorName: string
  rating: number
  text: string
}

export async function POST(request: Request) {
  try {
    const body = (await request.json()) as Partial<ReviewPayload>

    const payload: ReviewPayload = {
      recipeId: body.recipeId?.trim() ?? "",
      authorName: body.authorName?.trim() ?? "",
      rating: Number(body.rating ?? 0),
      text: body.text?.trim() ?? "",
    }

    const errors: Partial<Record<keyof ReviewPayload, string>> = {}

    if (payload.recipeId.length === 0) {
      errors.recipeId = "Не передано recipeId."
    }

    if (payload.authorName.length < 2) {
      errors.authorName = "Вкажіть ім’я довжиною щонайменше 2 символи."
    }

    if (!Number.isInteger(payload.rating) || payload.rating < 1 || payload.rating > 5) {
      errors.rating = "Оцінка має бути від 1 до 5."
    }

    if (payload.text.length < 10) {
      errors.text = "Відгук має містити щонайменше 10 символів."
    }

    if (Object.keys(errors).length > 0) {
      return NextResponse.json(
        { ok: false, message: "Помилка валідації.", errors },
        { status: 400 }
      )
    }

    const supabaseServer = await createSupabaseServerClient()
    const {
      data: { user },
    } = await supabaseServer.auth.getUser()

    const supabase = createSupabaseAdminClient()

    const { data, error } = await supabase
      .from("recipe_reviews")
      .insert({
        user_id: user?.id ?? null,
        recipe_id: payload.recipeId,
        author_name: payload.authorName,
        rating: payload.rating,
        text: payload.text,
        helpful_count: 0,
        status: "pending",
      })
      .select(
        "id, user_id, recipe_id, author_name, rating, text, helpful_count, status, created_at"
      )
      .single()

    if (error) {
      return NextResponse.json(
        { ok: false, message: error.message },
        { status: 500 }
      )
    }

    return NextResponse.json({
      ok: true,
      message: "Відгук збережено і передано на модерацію.",
      data: {
        id: data.id,
        recipeId: data.recipe_id,
        authorName: data.author_name,
        rating: data.rating,
        text: data.text,
        helpfulCount: data.helpful_count,
        status: data.status,
        createdAt: data.created_at,
      },
    })
  } catch {
    return NextResponse.json(
      { ok: false, message: "Не вдалося обробити відгук." },
      { status: 500 }
    )
  }
}